import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import React from "react";
import { css } from "styled-components";

export interface ContactUsPageStyles {
    pageStyles?: MobiusPageProps;
}

export const contactUsPageStyles: ContactUsPageStyles = {
    pageStyles: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 25px;
                        `,
                        null,
                        null,
                        css`
                            padding: 100px;
                        `,
                    ],
                    "min",
                );
            }}
        `,
    },
};

const ContactUsPage = ({ id }: PageProps) => {
    const styles = contactUsPageStyles;
    return (
        <Page {...styles.pageStyles}>
            <Zone contentId={id} zoneName="Content"></Zone>
            <Modals />
        </Page>
    );
};

const pageModule: PageModule = {
    component: ContactUsPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;

export const ContactUsPageContext = "ContactUsPage";
